<template>
  <div>
    <div class="sendrecord-select">
      <crumb-tit :roots="roots">
        <span slot="breadTit">{{ isAdd ? $t('message["1190"]') + 'Webhook' : '编辑Webhook' }}</span>
      </crumb-tit>
    </div>
    <div
      v-if="webhookDetailIsReady"
      class="add-webhook-form"
    >
      <a-form
        :form="form"
        @submit.prevent="saveForm"
      >
        <a-form-item label="名称">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: enterPlaceholder }], initialValue: webhookDetail.name || ''}]"
            :placeholder="enterPlaceholder"
            @change="getName"
          />
        </a-form-item>
        <a-form-item label="类型">
          <a-radio-group
            v-decorator="['type', {rules: [{ required: true, message: selectPlaceholder }],initialValue: webhookDetail.type ? webhookDetail.type+ '': '1'}]"
            @change="getType"
          >
            <a-radio value="1">
              {{ $t('message["1660"]') }}
            </a-radio>
            <a-radio value="2">
              企微机器人
            </a-radio>
            <a-radio value="3">
              钉钉机器人
            </a-radio>
            <a-radio value="4">
              智能音箱
              <em class="type-tip">（目前仅支持360AI音箱）</em>
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="接收地址">
          <a-input
            v-decorator="[
              'path',
              {
                rules: [{ required: true, message: enterPlaceholder }, { validator: isUrlValid }],
                initialValue: webhookDetail.path || ''
              }
            ]"
            placeholder="https://example.com"
            @change="getPath"
          />
        </a-form-item>
        <template>
          <!-- <a-form-item
            v-if="type * 1 === 1"
            label="校验密钥"
          >
            <a-input
              v-decorator="['secret', { initialValue: webhookDetail.type === 1 && webhookDetail.setting ? webhookDetail.setting.secret : '' || ''}]"
              placeholder="请输入"
            />
            <p class="webhook-v-tip">
              如果您的webhook地址接收推送设置的有校验密钥，请在此输入，没有可不填
            </p>
          </a-form-item> -->
          <a-form-item
            v-if="type === 3"
            class="safe-setting"
          >
            <span slot="label">
              安全设置
              <a-popover
                placement="bottom"
                overlay-class-name="safe-hover-tip"
              >
                <template slot="content">
                  <p>在创建钉钉机器人进行的安全设置类型</p>
                </template>
                <i class="iconfont iconicon-test34" />
              </a-popover>
            </span>
            <a-radio-group
              v-decorator="['safeSetting', {
                rules: [{
                  required: true,
                  message: selectPlaceholder
                }],
                initialValue: settingType
              }]"
              @change="getSafeType"
            >
              <a-radio value="1">
                自定义关键词
              </a-radio>
              <a-radio value="2">
                加签
              </a-radio>
              <a-radio value="3">
                IP地址（段）
              </a-radio>
            </a-radio-group>
            <template>
              <p
                v-if="safeSetting === 1"
                class="safe-tip"
              >
                请务必在在推送数据中，加入在钉钉机器人上-安全设置中设置的关键词，否则数据将无法正常推送至钉钉
              </p>
              <p
                v-else-if="safeSetting === 3"
                class="safe-tip"
              >
                请务必将IP {{ ipAdress }} 配置到在钉钉机器人中，否则数据将无法正常推送至钉钉
              </p>
              <a-form-item v-else-if="safeSetting === 2">
                <a-input
                  v-decorator="['secret2', { rules: [{ required: true, message: '请输入钉钉机器人的密钥' }], initialValue: webhookDetail.type === 3 && webhookDetail.setting ? webhookDetail.setting.secret : '' || ''}]"
                  placeholder="请输入钉钉机器人的密钥"
                  @change="getSecret"
                />
              </a-form-item>
            </template>
          </a-form-item>
        </template>
        <a-form-item label="推送事件">
          <a-table
            :columns="eventColumns"
            :data-source="eventListData"
            :pagination="false"
          >
            <div
              slot="event"
              slot-scope="text, record"
            >
              <a-checkbox
                :checked="!!record.status"
                @change="changeHandler(record, $event)"
              >
                {{ text }}
              </a-checkbox>
            </div>
            <div
              slot="jsondata"
              slot-scope="text, record"
            >
              <a
                href="javascript:;"
                @click="getJsonDialog(record)"
              >{{ $t('message["1008"]') }}</a>
              <span
                v-if="!!record.status && Object.keys(record.data).length ===0 "
                class="event-t-tip"
              >请设置该事件下的推送数据格式</span>
            </div>
          </a-table>
          <set-json-dia
            ref="setJsonDialog"
            :datas="jsonDatas"
            :item-data="itemData"
            @validJson="validJson"
          />
        </a-form-item>
        <!-- <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["21"]') }}
          </a-button>
        </a-form-item> -->
        <div
          ref="footerBtn"
          class="footer-wrap"
        >
          <div
            ref="footer"
            class="footer"
            :class="{'ani':isShowBtn}"
          >
            <a-button
              type="primary"
              html-type="submit"
              :disabled="isBtnDisable"
            >
              {{ $t('message["21"]') }}
            </a-button>
            <!-- <a-button @click="handleCancel">
            取消
          </a-button> -->
            <span class="sub-tip">{{ $t('message["22"]') }}？</span>
          </div>
        </div>
      </a-form>
      <leave-tip-dialog
        ref="leaveTip"
        @leavelHandler="leavelHandler"
      >
        <div slot="tip-slot">
          {{ $t('message["1512"]') }}，<br>
          {{ $t('message["920"]') }}？
        </div>
      </leave-tip-dialog>
    </div>
    <div
      v-else
      class="empty-tip"
    >
      <a-spin />
    </div>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import SetJsonDia from '@/components/pc/config/webhook/SetJson'
import { mapState, mapActions, mapMutations } from 'vuex'
import LeaveTipDialog from '@/components/pc/LeaveTipDialog'
export default {
  components: {
    CrumbTit,
    SetJsonDia,
    LeaveTipDialog
  },
  data () {
    return {
      form: this.$form.createForm(this),
      type: 3,
      safeSetting: 1,
      itemData: {},
      jsonDatas: {},
      leave: {},
      status: false,
      count: 0,
      isBtnDisable: true,
      isShowBtn: false
    }
  },
  computed: {
    ...mapState('config/webhook', ['eventColumns', 'eventListData', 'webhookDetailIsReady', 'webhookDetail']),
    isAdd () {
      return !this.$route.query.hookid * 1
    },
    roots () {
      return {
        to: 'configWebhookList',
        title: this.$t('message["282"]')
      }
    },
    hookid () {
      return this.$route.query.hookid
    },
    ipAdress () {
      let ip = ''
      const hostname = window.location.hostname
      if (hostname.indexOf('dev') > -1) {
        ip = '123.160.246.41'
      } else {
        ip = hostname.indexOf('dtwork') > -1 ? '129.204.142.43' : '129.204.142.43'
      }
      return ip
    },
    settingType () {
      const { setting = {} } = this.webhookDetail
      const { type } = setting
      if (type) {
        return type + ''
      } else {
        return '1'
      }
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    comProjectName () {
      const { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      return `- ${projectname} - ${comname}`
    }
  },
  watch: {
    webhookDetail: {
      handler (val) {
        if (val) {
          this.count++
          if (this.count > 1 && this.$route.name === 'configAddWebhook') {
            this.removeClick()
            this.addClick()
            this.isShowBtn = true
            this.isBtnDisable = false
          }
        }
      },
      deep: true
    }
  },
  beforeRouteLeave (to, from, next) {
    this.removeClick()
    if (this.count > 1) {
      if (this.status) {
        next()
        return
      }
      this.$refs.leaveTip.changeLimitDialog(true)
      this.leave = to
      next(false)
    } else {
      next()
    }
  },
  async mounted () {
    const chain = await this.getWebhookDetail({ hookid: this.hookid })
    chain.onSuccess(raw => {
      const { isAdd, comProjectName } = this
      this.type = raw.type * 1 || 1
      if (raw.type * 1 === 3) {
        this.safeSetting = raw.setting.type * 1
      }
      document.title = isAdd ? '添加Webhook ' + comProjectName : '编辑Webhook' + comProjectName
      this.setFooterStyle()
      window.addEventListener('resize', this.setFooterStyle)
      document.addEventListener('scroll', this.setFooterStyle)
    })
      .fetch()
  },
  methods: {
    ...mapActions('config/webhook', ['getWebhookDetail', 'addEditWebhook', 'getInitJsonData', 'validForm', 'removeClick', 'addClick']),
    ...mapMutations('config/webhook', ['setwebhookDetail']),
    async saveForm () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        const { eventListData } = this
        const isNoValid = eventListData.some(item => item.status === 1 && (Object.keys(item.data).length === 0))
        const { hookid } = this
        // const evetData = eventListData.filter(item => item.status === 1 && (Object.keys(item.data).length > 0))
        // console.log(evetData)
        if (!err && !isNoValid) {
          const valuesData = this.getValues(values)
          const obj = { ...valuesData, webhook_event: eventListData, hookid }

          const chain = await this.addEditWebhook(obj)
          chain.onSuccess(() => {
            this.status = true
            setTimeout(() => {
              this.$router.push({ 'name': 'configWebhookList' })
            }, 1000)
          })
            .fetch()
        }
      })
    },
    getName (e) {
      const val = (e.target.value).trim()
      this.webhookDetail.name = val
    },
    getPath (e) {
      this.webhookDetail.path = (e.target.value).trim()
    },
    getSecret (e) {
      this.webhookDetail.setting.secret = (e.target.value).trim()
    },
    changeHandler (item, e) {
      item.status = e.target.checked ? 1 : 0
    },
    async getType (e) {
      this.type = e.target.value * 1
      this.webhookDetail.type = this.type
      this.setwebhookDetail(this.webhookDetail)
      const chain = await this.getWebhookDetail({ hookid: this.hookid, type: this.type })
      chain.onSuccess(raw => {
        // this.type = raw.type * 1 || 1
        // if (raw.type * 1 === 3) {
        //   this.safeSetting = raw.setting.type * 1
        // }
      })
        .fetch()
    },
    getSafeType (e) {
      this.safeSetting = e.target.value * 1
      if (this.webhookDetail.setting) {
        this.webhookDetail.setting.type = e.target.value * 1
      } else {
        this.webhookDetail.setting = {}
        this.webhookDetail.setting.type = e.target.value * 1
      }
    },
    async getJsonDialog (item) {
      const b = Object.keys(item.data).length > 0
      this.itemData = item
      if (b) {
        this.jsonDatas = item.data
        this.$refs.setJsonDialog.changeVisible(true)
      } else {
        const chain = await this.getInitJsonData({ type: item.type })
        chain.onSuccess(raw => {
          this.jsonDatas = raw
          this.$refs.setJsonDialog.changeVisible(true)
        })
          .fetch()
      }
    },
    getValues (values) {
      const { type, safeSetting } = this
      if (type === 1) {
        // values['setting'] = {
        //   secret: values['secret']
        // }
        // this.$delete(values.setting, 'type')
        // this.$delete(values, 'secret')
      } else if (type === 3) {
        values['setting'] = {
          secret: values['secret2'],
          type: values.safeSetting
        }
        if (safeSetting !== 2) {
          this.$delete(values.setting, 'secret')
        }
        this.$delete(values, 'secret2')
        this.$delete(values, 'safeSetting')
      } else {
        values['setting'] = {}
      }
      return values
    },
    validJson (item, data) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        const { hookid } = this
        if (!err) {
          const valuesData = this.getValues(values)
          const obj = { ...valuesData, data: data, eventtype: item.type, hookid }

          const chain = await this.validForm(obj)
          chain.onSuccess(raw => {
            // this.$router.resolve()
            const resolve = this.$router.resolve({
              path: `sendrecord/${this.hookid}`,
              params: { hookid: this.hookid }
            })
            window.open(resolve.href, '_blank')
          })
            // .onNetSuccess(raw => {
            //   this.$message.success((h) => {
            //     return (
            //       <div style="display:inline;">
            //         { raw.data.message },
            //         <a href="javascript:;" onClick={() => {
            //           this.$router.push({
            //             name: 'configSendRecord',
            //             params: { hookid: this.hookid }
            //           })
            //           // this.duration = 0
            //         }}
            //         >查看推送记录</a>
            //       </div>
            //     )
            //   }, 5)
            // })
            .fetch()
        } else {
          this.$message.error('表单页面必填项，请填写完整')
        }
      })
    },
    isUrlValid (rule, value, callback) {
      const newrg = /^(https?):\/\/[^\s]+$/i
      if (!newrg.test(value)) {
        callback(new Error('接收地址格式不正确'))
      } else {
        callback()
      }
    },
    viewSendRecord () {
      this.$route.push({ name: 'configSendRecord', params: { hookid: this.hookid } })
    },
    leavelHandler (b) {
      const { leave } = this
      if (b) {
        this.status = true
        // this.setDatas(this.cloneData)
        this.$router.push({ name: leave.name, query: leave.query, params: leave.params })
      } else {
        this.status = false
      }
      this.$refs.leaveTip.changeLimitDialog(false)
    },
    setFooterStyle () {
      this.$nextTick(() => {
        if (!this.$refs.footer) return

        const $footer = this.$refs.footer

        $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        // console.log(getScrollTop(), $footer.parentNode, $footer.parentNode.offsetTop)
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        // console.log(sectionWidth, pageWidth, $footer.parentNode.offsetLeft)
        if ($footer.parentNode.offsetTop - this.$getScrollTop() - window.innerHeight + $footer.parentNode.offsetHeight + 44 < 0) {
          $footer.style.position = 'relative'
          $footer.style.left = 0
        } else {
          $footer.style.position = 'fixed'
          $footer.style.left = pageWidth <= sectionWidth ? $footer.parentNode.offsetLeft + 1 + 'px' : $footer.parentNode.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
        }
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.footer-wrap {
    height: 64px;
    margin-top: 40px;
  }
  .footer {
    position: fixed;
    bottom: -89px;
    left: 0;
    height: 64px;;
    z-index: 999;
    margin-left: -40px;
    padding: 16px 80px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    transition: bottom 0.5s linear;
    .ant-btn {
      margin-right: 0 ;
    }
    span.sub-tip {
      color: #b3b3b3;
      margin-left: 10px;
    }
    opacity: 0;
  }
  .ani {
    bottom: 0;
    opacity: 1;
  }
.empty-tip {
  text-align: center;
  margin-top: 60px;
}
.sendrecord-select::v-deep {
  .crumb-title {
    padding: 0 0 24px;
    .second-tit {
      display: none;
    }
  }
}
.add-webhook-form::v-deep {
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {
    padding-left: 120px;
    .ant-form-item-label {
      float: left;
      width: 110px;
      margin-left: -120px;
      label {
      color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
      .ant-checkbox-wrapper {
        margin-bottom: 0;
      }
      span.ant-radio + * {
        padding-left: 0;
      }
      .ant-row {
        padding-left: 0;
        margin-bottom: 0;
      }
      // .ant-btn {
      //   margin-left: 15px;
      // }
    }
    .webhook-v-tip {
      color: #b3b3b3;
      line-height: 18px;
      margin-top: 6px;
      padding-left: 12px;
      font-size: 12px;
    }
    .event-t-tip {
      color: #f57676;
      margin-left: 10px;
    }
    .safe-tip {
      color: #F6A953;
      line-height: 18px;
      font-size: 12px;
    }
    .iconicon-test34 {
      color: #d6d6d6;
      vertical-align: middle;
    }
    .type-tip{
      color: #b3b3b3;
      font-style: normal;
    }
  }
}
</style>
